import Header from "./header"
import {useLocation} from "react-router-dom"
import {useEffect, useState} from "react"
import Onboarding from "../onboarding"
import ApiAuth from "../../services/auth"
import Footer from "./footer"
import {eventTag} from "../../services/utils"

export default function Layout({ children, ...props }) {
  const { pathname } = useLocation()
  const [showOnboarding, setShowOnboarding] = useState(false)
  const { account } = { ...props }
  const onboarding = JSON.parse(localStorage.getItem("onboarding")) || ""
  const location = useLocation()
  const howToUsePage = location.pathname === "/como-utilizar"

  const closeOnboarding = () => {
    ApiAuth()
      .finishOnboarding()
      .catch((e) => {
        console.error(e)
      })
      .finally(() => {
        localStorage.setItem("onboarding", JSON.parse("false"))
        setShowOnboarding(false)
        eventTag("onboarding", "onboarding", "modal", "Fechar onboarding")
      })
  }

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "auto",
    })
  }, [pathname])
  useEffect(() => {
    if (!!account) {
      if (localStorage.getItem("onboarding") === "true") {
        ApiAuth()
          .skipOnboarding()
          .then((r) => {
            const { data } = r
            if (data.onboarding) {
              localStorage.setItem("onboarding", JSON.parse("false"))
            }
            setShowOnboarding(!data.onboarding)
          })
          .catch((e) => {
            console.error(e)
            // setShowOnboarding(!account?.unauthorized)
          })
      }
    }
  }, [account])
  useEffect(() => {
    if (showOnboarding && onboarding) {
      eventTag("onboarding", "onboarding", "modal", "Mostrar onboarding")
      document.body.style.overflow = "hidden"
    } else {
      document.body.style.overflow = ""
    }
    // eslint-disable-next-line
  }, [showOnboarding])
  return (
    <div className="app">
      <Header {...props} />
      <main className={`${account ? "auth" : "guest"} ${showOnboarding && onboarding ? 'has-onboarding' : ''}`}>
        {showOnboarding && onboarding ? (
          <Onboarding
            callBack={() => closeOnboarding()}
            setHideOnboarding={() => {
              setShowOnboarding(false)
            }}
          />
        ) : (
          ""
        )}
        {children}
      </main>
      {!howToUsePage && (
        <Footer
          typeFooter={account ? "auth" : "guest"}
          {...props}
        />
      )}
    </div>
  )
}
